import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useListMemberPagination = () =>
  useStore(store => ({
    pageInfo: store.listMembersPagination.state,
    setPage: store.listMembersPagination.execute,
  }))
